// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialRenren = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.718 6v3.585l-.371.935c-.756 1.879-1.62 3.767-3.006 4.727A5.666 5.666 0 0 1 6.49 6.044zm.94 11.253a5.64 5.64 0 0 1-2.717-.695c1.312-.83 2.365-2.08 2.718-3.54.353 1.46 1.406 2.71 2.718 3.54a5.617 5.617 0 0 1-2.718.696zm8.683 0a5.623 5.623 0 0 1-2.718-.695c1.312-.83 2.365-2.08 2.718-3.54.353 1.46 1.406 2.71 2.718 3.54a5.634 5.634 0 0 1-2.718.696zm-4.156-2.11-.203.103c.836-.988 1.377-2.264 1.377-3.659 0-1.396-.541-2.673-1.377-3.66a5.647 5.647 0 0 0-1.34 3.66c0 1.395.505 2.671 1.34 3.659-1.92-.931-3.28-2.999-3.371-5.426l-.005-.262V6a5.656 5.656 0 0 1 3.376 1.927 5.729 5.729 0 0 1 3.146-1.876L15.394 6v3.585c-.006 2.442-1.333 4.55-3.209 5.558zm8.474.103c-1.92-.931-3.28-2.999-3.372-5.426l-.005-.262V6a5.667 5.667 0 0 1 3.377 9.246z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialRenren;
